
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  Blockquote,
  HardBreak,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";

@Component({
  components: {
    EditorContent,
    EditorMenuBar,
  },
})
export default class JbEditor extends Vue {
  @Prop(String) readonly value!: string;

  keepInBounds: boolean = true;
  editor: any | null = null;

  mounted() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new HardBreak(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
      ],
      content: this.value,
      onUpdate: ({ getHTML }: any) => {
        this.$emit("input", getHTML());
      },
    });
    // @ts-ignore
    this.editor.setContent(this.value);
  }

  updated() {
    // @ts-ignore
    this.editor.setContent(this.value, true);
  }

  beforeDestroy() {
    // @ts-ignore
    this.editor.destroy();
  }

  @Watch("value")
  onValueChange(val: any) {
    if (this.editor && val !== this.value) {
      // @ts-ignore
      this.editor.setContent(val, true);
    }
  }
}
